<template>
  <div v-if="pin" :class="{ row: isClosing }">
    <div
      :class="[{ 'col-lg-6 col-md-6 col-12': isClosing }, { 'col-lg-9 col-md-9 col-12 mb-4': !isClosing }]"
      class="mb-4"
    >
      <h4>{{ $t('src/components/coursepincode.9804') }}</h4>
    </div>
    <div :class="{ 'col-lg-6 col-md-6 col-12': isClosing }" class="mb-4">
      <div data-testid="div-pin-code" class="alert alert-outline-primary alert-pin">
        {{ pin }}
      </div>
    </div>
    <div :class="{ 'col-lg-6 col-md-6 col-12': isClosing }">
      <div class="text-muted mt-2">
        <div data-testid="div-pin-code-valid-time" class="mb-2">{{ $t('src/components/coursepincode.6421') }}</div>
        <div data-testid="div-countdown" class="icon icon-clock icon_secondary text-icon">
          {{ leftTime }}
        </div>
      </div>
    </div>
    <div :class="{ 'col-lg-6 col-md-6 col-12': isClosing }">
      <slot name="underPin"></slot>
    </div>
  </div>
</template>

<script>
import { randNumbers } from '@/modules/generator.js'
import http from '@/modules/http.js'
import { nowMoment } from '@/mixins/now-moment'
const duration = 20 //в минутах

export default {
  name: 'CoursePinCode',
  mixins: [nowMoment],
  props: {
    courseId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    pin: null,
    createTime: null,
    expiredTime: null,
    leftTime: '',
    timer: null
  }),
  computed: {
    isClosing() {
      return Boolean(this.$parent.$el.id == 'courseClosing')
    }
  },
  created() {
    this.createNewPin()
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
  methods: {
    createNewPin() {
      randNumbers().then(pin => {
        http
          .patch('/courses/' + this.courseId, {
            link_pin: pin
          })
          .then(response => {
            this.pin = response.data.link_pin
            this.setExpiredTime()
          })
          .catch(error => console.log(error))
      })
    },
    setExpiredTime() {
      this.expiredTime = this.moment()
        .local()
        .add(duration, 'minutes')
      this.countdown()
    },
    countdown() {
      if (!this.expiredTime) {
        this.leftTime = ''
        return
      }
      const now = this.moment().local()
      const left = this.expiredTime.valueOf() - now.valueOf()

      this.leftTime = this.moment(left).format('mm:ss')

      if (this.expiredTime.isSameOrBefore(now)) {
        this.createNewPin()
        return
      }

      this.timer = setTimeout(this.countdown, 1000)
    }
  }
}
</script>
